// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ColumnChartOptionsBuilder.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import AreaChartOptionsBuilder from './Izenda.AreaChartOptionsBuilder';
import { RANGE_OPTION_KEYS } from 'logic/data/Izenda.ReportPartChartConstants';
import { flow, flatMap, forEach, merge } from 'lodash/fp';
import { exportClass } from 'share/Izenda.ServiceProvider';

@exportClass('ColumnChartOptionsBuilder')
export default class ColumnChartOptionsBuilder extends AreaChartOptionsBuilder {
  constructor(...baseArgs) {
    super(...baseArgs);
  }

  /**
   * Build Highchart variable options for each chart type
   * @param {string} visualType Highchart chart type
   * @param {Object} highchartOptions Highchart options
   * @param {Object} chartData Chart data
   * @return {Object} 
   */
  buildOptionsByType(visualType: string, userOptions: any, dataParser: any): any {
    const chartOptions = super.buildOptionsByType(visualType, userOptions, dataParser) || {};
    const { izendaOptions = {} } = userOptions;

    // Change y value to null to only show point has data
    flow(
      flatMap('data'),
      forEach(data => {
        data.isDefaultValue && (data.y = null);
      })
    )(chartOptions.series);

    // Range only options
    if (izendaOptions.range === RANGE_OPTION_KEYS.rangeOnly) {
      return merge(chartOptions, {
        chart: {
          type: 'columnrange'
        },
        plotOptions: {
          series: {
            minPointLength: 3
          }
        }
      });
    }

    return merge(chartOptions, {
      chart: {
        type: 'column'
      },
      xAxis: {
        crosshair: true
      }
    });
  }
}



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartChart/Izenda.ColumnChartOptionsBuilder.js